import React from "react";
import { Link } from "react-router-dom";
import style from "../../../css/dashboard/Screener.module.css";
import Screenerhistory from "./Screener_history";

const Screenerdash = () => {
  return (
    <div className={style.container}>

      <div className={style.cardGrid}>
        <Link to="ipo" className={style.card}>
          <div className={style.cardContent}>
            <h3>IPO</h3>
          </div>
        </Link>
        <Link to="vpc" className={style.card}>
          <div className={style.cardContent}>
            <h3>VCP</h3>
          </div>
        </Link>
        <Link to="rocket" className={style.card}>
          <div className={style.cardContent}>
            <h3>Rocket</h3>
          </div>
        </Link>
        <Link to="fno" className={style.card}>
          <div className={style.cardContent}>
            <h3>FNO</h3>
          </div>
        </Link>
      </div>

      <contentshow>
      <Screenerhistory />

      </contentshow>
      <p style={{ position: 'fixed', bottom: 0, right: 0, margin: '10px', fontSize: '1.6rem', color: 'gray' }}>
        Update every day at 8:00 PM
      </p>


    </div>
  );
};

export default Screenerdash;
